import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-289f26c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NewBreadcrumbs" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__divider" }, "/", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "NewBreadcrumbs__container",
        key: link.id
      }, [
        (i !== _ctx.links.length - 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_router_link, {
                class: "container__link",
                to: link.to
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(link.name), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              _hoisted_2
            ], 64))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              class: "container__link",
              to: link.to
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(link.name), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
      ]))
    }), 128))
  ]))
}